import type { IKeyword } from "../types";
import { rankingExibido, superficieDaPosicao } from "./keyword-link";

/** Acima disso a medição descreve o passado, não a posição de hoje. */
const DIAS_ATE_ENVELHECER = 30;

export type GruposDePalavras = {
  topo: IKeyword[];
  evoluindo: IKeyword[];
  antigas: IKeyword[];
};

const medidaEm = (keyword: IKeyword): Date | null => {
  const quando =
    superficieDaPosicao(keyword) === "pesquisa"
      ? keyword.serpMeasuredAt
      : keyword.measuredAt;
  if (!quando) return null;
  const data = new Date(quando);
  return Number.isNaN(data.getTime()) ? null : data;
};

const envelheceu = (keyword: IKeyword, hoje: Date): boolean => {
  const data = medidaEm(keyword);
  if (!data) return false;
  return (hoje.getTime() - data.getTime()) / 86_400_000 >= DIAS_ATE_ENVELHECER;
};

/**
 * Divide a lista do relatório em três blocos.
 *
 * O problema que isto resolve (relatório da GV Oficina, 04/09/2026): a lista era
 * ordenada só por posição, então 15 palavras medidas em JANEIRO abriam o
 * relatório exibindo selo verde de 1º lugar, e o trabalho atual ficava lá
 * embaixo como uma parede de "Ranqueando". Medição velha não disputa espaço
 * com medição de hoje: vai para o fim, separada e identificada.
 */
export const agruparPalavras = (
  palavras: IKeyword[],
  hoje: Date = new Date(),
): GruposDePalavras => {
  const grupos: GruposDePalavras = { topo: [], evoluindo: [], antigas: [] };

  palavras.forEach((keyword) => {
    if (envelheceu(keyword, hoje)) {
      grupos.antigas.push(keyword);
      return;
    }
    const posicao = rankingExibido(keyword);
    if (posicao >= 1 && posicao <= 3) {
      grupos.topo.push(keyword);
    } else {
      grupos.evoluindo.push(keyword);
    }
  });

  grupos.topo.sort((a, b) => rankingExibido(a) - rankingExibido(b));
  grupos.evoluindo.sort((a, b) => a.title.localeCompare(b.title));
  grupos.antigas.sort((a, b) => rankingExibido(a) - rankingExibido(b));

  return grupos;
};
